'use strict';
angular.module('cvsApp').factory('healthCheckUpModel',['commonModel',function(CM) {	
	
	var healthCheckupModel = function(){

		var self = this;

		self.headers = {};
		
		
		this.setHeaders = function(value){
			self.headers = value
		}

		this.getHeaders = function(){
			return self.headers;
		}
			
	}
	
	return new healthCheckupModel();
}]);